import { createError } from '../../../../../lib/error';

class NetworkSettingsModalController {
  constructor(
    $scope,
    $uibModalInstance,
    $translate,
    $q,
    $rootScope,
    APIService,
    DEBUG,
    staffUser
  ) {
    "ngInject";
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.$translate = $translate;
    this.$q = $q;
    this.$rootScope = $rootScope;
    this.APIService = APIService;
    this.DEBUG = DEBUG;
    this.staffUser = staffUser;

    this._isOfflineMode = !!this.APIService.isOfflineMode;
  }

  close() {
    this.$uibModalInstance.close();
    this.APIService.isOfflineMode = this.isOfflineMode;
  }

  refreshPositions() {
    this.close();
    this.$rootScope.$emit('sync');
  }

  get deviceNetworkIsOnline() {
    return this.APIService.isDeviceOnline;
  }

  set isOfflineMode(isOfflineMode) {
    this._isOfflineMode = isOfflineMode;
  }

  get isOfflineMode() {
    return this._isOfflineMode;
  }
}

export default NetworkSettingsModalController;
